
export const ApiErrorSymbol = Symbol('ApiError')

export default (message: string, body: Object) => {
  const error = {message, body}
  Reflect.defineProperty(error, ApiErrorSymbol, {value: true, enumerable: true, writable: false})
  return error
}


// WEBPACK FOOTER //
// ./src/api/utils/createApiError.tsx